import { render } from "./ViewProjects.vue?vue&type=template&id=3a52effa&scoped=true"
import script from "./ViewProjects.vue?vue&type=script&lang=js"
export * from "./ViewProjects.vue?vue&type=script&lang=js"

import "./ViewProjects.vue?vue&type=style&index=0&id=3a52effa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a52effa"]])

export default __exports__